import UserDispatcherEditFormResponse, {
  UserDispatcherEditFormResponseUser,
  UserDispatcherEditFormResponseDispatch,
  UserDispatcherEditFormResponseAvailableDispatch,
} from "../../../../api/raily/user/dispatcher/edit-form/user-dispatcher-edit-form.response";
import UserDispatcherEditForm, {
  UserDispatcherEditFormDispatch,
} from "./user-dispatcher-edit-form";

const createAlternativePhoneNumber = (
  responseUser: UserDispatcherEditFormResponseUser,
): UserDispatcherEditForm["alternativePhoneNumber"] => {
  if (!responseUser.mobileSecondary || !responseUser.mobileSecondaryPrefix) {
    return null;
  }

  return {
    dialingCode: responseUser.mobileSecondaryPrefix,
    number: responseUser.mobileSecondary,
  };
};

const createPhoneNumber = (
  responseUser: UserDispatcherEditFormResponseUser,
): UserDispatcherEditForm["phoneNumber"] => {
  return {
    dialingCode: responseUser.mobilePrimaryPrefix,
    number: responseUser.mobilePrimary,
  };
};

const createDispatch = (
  responseDispatch: UserDispatcherEditFormResponseDispatch,
): UserDispatcherEditFormDispatch => {
  return {
    address: responseDispatch.addressString,
    displayName: responseDispatch.displayName,
    name: responseDispatch.dispatchName,
    uuid: responseDispatch.id,
  };
};

const createAvailableDispatch = (
  responseAvailableDispatch: UserDispatcherEditFormResponseAvailableDispatch,
): UserDispatcherEditFormDispatch => {
  return {
    address: responseAvailableDispatch.addressString,
    displayName: responseAvailableDispatch.displayName,
    name: responseAvailableDispatch.dispatchName,
    uuid: responseAvailableDispatch.id,
  };
};

const createAvailableDispatches = (
  responseAvailableDispatches: UserDispatcherEditFormResponseAvailableDispatch[],
): UserDispatcherEditFormDispatch[] => {
  return responseAvailableDispatches.map(createAvailableDispatch);
};

const create = (
  response: UserDispatcherEditFormResponse,
): UserDispatcherEditForm => {
  return {
    email: response.data.user.email,
    alternativePhoneNumber: createAlternativePhoneNumber(response.data.user),
    availableDispatches: createAvailableDispatches(
      response.data.availableDispatches,
    ),
    dispatch: createDispatch(response.data.dispatch),
    firstName: response.data.user.firstName,
    lastName: response.data.user.lastName,
    phoneNumber: createPhoneNumber(response.data.user),
    username: response.data.user.username,
  };
};

const userDispatcherEditFormFactory = {
  create,
};

export default userDispatcherEditFormFactory;
